import _, { isEmpty } from 'lodash';
import { browserHistory } from 'react-router';
import { JSEncrypt } from 'jsencrypt';
import moment from 'moment-timezone';
import momentDateAndTime from 'moment';
import { store } from '../redux/store';
import {
  resetRedux,
  notifySet,
  onlineSet,
  goBackSet,
  userSet
} from '../redux/actions';
import { SECRET_PUBLIC_KEY, APP_VERSION } from './config';

// eslint-disable-next-line import/no-cycle
import { deleteDb } from '../utils/db';

import Bugsnag from '../helpers/bugsnag';

export const USER_STORAGE_KEY = 'OPTIMIZE_USER_DATA';

export const FIRST_LOGIN_TOKEN_KEY = 'FIRST_LOGIN_TOKEN_DATA';

export const SERVER_URL_STORAGE_KEY = 'SERVER_URL_DATA';

export const LIST_CASE_DATE_KEY = 'LIST_CASE_DATE';

export const SERVER_TIMEZONE = 'America/New_York';

export const USERNAME_STORAGE_KEY = 'OPTIMIZE_USERNAME_DATA';

export const SYNC_DATE_KEY = 'SYNC_DATE';

export const SYNC_TEAM_ABB_KEY = 'SYNC_TEAM_ABB';

export const LAST_VISITED_ROUTE = 'LAST_VISITED_ROUTE';

export const SYNC_INVENTORY_DATE_KEY = 'SYNC_INVENTORY_DATE';

export const INVENTORY_FLAG = 'INVENTORY_FLAG';

export const DER_FLAG = 'DER_FLAG';

export const THEME_COLOR = 'THEME_COLOR';

export const THEME_COLOR_NUMBER = 'THEME_COLOR_NUMBER';

export const DEFAULT_USER = {
  id: null,
  userName: '',
  office: null,
  team: null,
  token: '',
  selectedTeam: null
};

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

// STORE USER IN LOCAL STORAGE
export const storeUser = (user) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

// STORE USER IN LOCAL STORAGE
export const storeVersionCode = () => {
  localStorage.setItem('VERSION_CODE', APP_VERSION);
};

export const storeFirstLoginToken = (token) => {
  localStorage.setItem(FIRST_LOGIN_TOKEN_KEY, token);
};

export const isDev = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');

// GET USER FROM LOCAL STORAGE
export const getUser = () => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user !== 'null' && !isEmpty(user) ? JSON.parse(user) : DEFAULT_USER;
};

export const getFirstLoginToken = () => localStorage.getItem(FIRST_LOGIN_TOKEN_KEY);

export const clearAll = async (isSessionExpired = false, next) => {
  const user = await JSON.parse(localStorage.getItem(USER_STORAGE_KEY));
  if (isSessionExpired) {
    user.sessionToken = null;
    await localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
    store.dispatch(userSet(user));
  } else {
    const remember = user !== null && user.hasOwnProperty('remember') ? user.remember : {};
    if (user !== null) {
      user.remember = remember;
    }
    await localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
  }
  await next(true);
};

// REMOVE USER FROM REDUX & LOCAL STORAGE
export const userLogout = async (isSessionExpired = false) => {
  const color = await getThemeColor();
  const colorNumber = await getThemeColorNumber();

  await clearAll(isSessionExpired, () => {
    setTimeout(() => {
      if (isSessionExpired) {
        store.dispatch(
          notifySet({
            type: 'warning',
            message: 'Your session has expired.',
          }),
        );
      } else {
        deleteDb();
        window.localStorage.clear();
        storeThemeColor(color);
        storeThemeColorNumber(colorNumber);

        store.dispatch(resetRedux());
        // store.dispatch(
        //   notifySet({
        //     type: 'success',
        //     message: 'You have successfully signed out.',
        //   }),
        // );
      }
      window.location = '/';
    }, 500);
  });
};

export const getRouteExtraParams = (location, routes) => {
  const currentRoute = routes.filter(({ path }) => {
    const currentSplitedRoute = location.pathname.split('/');
    const splitedRoute = path.split('/');
    splitedRoute.map((slug, index) => {
      if (slug.indexOf(':') > -1) {
        delete currentSplitedRoute[index];
        delete splitedRoute[index];
      }
    });
    return splitedRoute.join('/') === currentSplitedRoute.join('/');
  });

  return currentRoute.length > 0 ? currentRoute[0].extra : {};
};

export const encryptPassword = (password) => {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(SECRET_PUBLIC_KEY);
  const encryptedPassword = encrypt.encrypt(password);
  return encryptedPassword;
};

export const LONG_PRESS_PARAMS = {
  threshold: 1000,
  captureEvent: true,
  detect: 'both'
};

export const passwordWithTimestamp = (password) => {
  // Add timestamp to password
  const timestamp = Date.now();
  return password.slice(0, 2) + timestamp + password.slice(2);
};

// Get online/offline
export const getOnlineOffline = () => {
  window.addEventListener('load', () => {
    navigator.onLine
      ? store.dispatch(onlineSet(true))
      : store.dispatch(onlineSet(false));
  });

  window.addEventListener('online', () => {
    store.dispatch(onlineSet(true));
  });

  window.addEventListener('offline', () => {
    store.dispatch(onlineSet(false));
  });
};

export const renderAlphabetically = (setsData, sortColumn) => {
  const data = setsData.reduce((r, e) => {
    const group = e[sortColumn][0];
    if (!r[group]) r[group] = { group, children: [e] };
    else r[group].children.push(e);
    return r;
  }, {});

  const result = Object.values(data);
  const sortedObjs = _.sortBy(result, 'group');

  return sortedObjs;
};

// STORE USER IN LOCAL STORAGE
export const storeServerUrl = (data) => {
  localStorage.setItem(SERVER_URL_STORAGE_KEY, JSON.stringify(data));
};

// GET USER FROM LOCAL STORAGE
export const getServerUrl = async () => {
  const serverData = await localStorage.getItem(SERVER_URL_STORAGE_KEY);
  const url = serverData != null && Object.keys(serverData).length > 0
    ? JSON.parse(serverData)
    : {};
  return `${url.server}`;
};

export const getAPIUrl = async () => {
  const serverData = await localStorage.getItem(SERVER_URL_STORAGE_KEY);
  const url = serverData != null && Object.keys(serverData).length > 0
    ? JSON.parse(serverData)
    : {};
  return `${url.aipUrl}`;
};

export const ALPHANUMERIC = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ#'.split('');

export const countImplantInstrument = (data) => {
  let implantQty = 0;
  let instrumentQty = 0;
  (data !== undefined && data !== '')
    && data.map((item) => {
      if (item.DeviceType === 'IMPLANT') {
        implantQty += item.Quantity;
      } else if (item.DeviceType === 'INSTRUMENT') {
        instrumentQty += item.Quantity;
      }
    });
  return { implantQty, instrumentQty };
};

export const updateQuantityValue = (sets, selectedQty, masterSelectedQty) => {
  sets.map((item, key) => {
    sets[key].Quantity = selectedQty[item.SetName] ? selectedQty[item.SetName] : 0;
  });
  return sets.filter(({ Quantity, SetName }) => (Quantity > 0 || masterSelectedQty[SetName]));
};

export const onGoBack = (goBack) => {
  browserHistory.push((goBack && goBack.length > 0) ? `${goBack[goBack.length - 1]}` : browserHistory.goBack);
  if (goBack) {
    goBack.pop();
    goBackSet(goBack);
  }
};

// CONVERT OBJECT TO QUERY STRING
export const queryString = (obj) => {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }
  return str.join('&');
};

// CONVERT OBJECT TO QUERY ARRAY
export const queryArray = (obj) => {
  const str = [];
  for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${JSON.stringify(obj[p])}`);
    }
  }
  return str.join('&');
};

// GET USER SESSION TOKEN FOR API
export const getAuthToken = async () => {
  const user = getUser();
  return (isEmpty(user) ? '' : user.sessionToken);
};

// GET USER ID
export const getUserId = async () => {
  const user = await getUser();
  return (isEmpty(user) ? '' : user.userId);
};

// GET SELECTED TEAM
export const getSelectedTeamName = async () => {
  try {
    const user = await getUser();
    return (isEmpty(user) ? '' : user.selectedTeam.name);
  } catch (e) {
    Bugsnag.notify(e);
  }
};

// GET USER TOKEN FOR API
export const getUserToken = async () => {
  const user = await getUser();
  return (isEmpty(user) ? '' : user.token);
};

// GET USER KEY FOR API
export const getUserKey = async () => {
  const user = await getUser();
  return (isEmpty(user) ? '' : user.userKey);
};

// GET USER KEY FOR API
export const getUserLoginPayload = async () => {
  const user = await getUser();
  return (isEmpty(user) ? '' : user.loginPayload);
};

export const sortData = (arrObj, key) => (_.sortBy(arrObj, key));

export const convertFormData = async (data) => {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
};

export const buildFormData = (formData, data, parentKey) => {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
};

export const getOrderByCases = async (data, sortOrder) => _.orderBy(data, 'CaseDate', sortOrder);

// CURRENCY CONVERTER
export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

// UNSHIFT "NONE"
export const getNoneAtTop = async (data, sortKey) => {
  let spliceObj = {};
  const resolvePromiseAll = data.map((gender, key) => {
    if (gender[sortKey] === 'NONE') {
      const a = data.splice(key, 1);
      // eslint-disable-next-line prefer-destructuring
      spliceObj = a[0];
    }
  });
  await Promise.all(resolvePromiseAll);
  data.unshift(spliceObj);
  return data;
};

// GET SELECTED DATETIME
export const getSelectedDateTime = (date, time) => {
  const timeArr = time.split(':');
  return moment(date).set('hour', timeArr[0]).set('minute', timeArr[1])._d;
};

// OVERWRITE CONSOLE LOG FOR PROD AND DEV
const _log = console.log;
const _error = console.error;
const _warning = console.warn;
const _info = console.info;

window.console.error = function () {
  if (isDev) {
    // eslint-disable-next-line prefer-rest-params
    _error.apply(console, arguments);
  }
};

window.console.log = function () {
  if (isDev) {
    // eslint-disable-next-line prefer-rest-params
    _log.apply(console, arguments);
  }
};

window.console.warn = function () {
  if (isDev) {
    // eslint-disable-next-line prefer-rest-params
    _warning.apply(console, arguments);
  }
};

window.console.info = function () {
  if (isDev) {
    // eslint-disable-next-line prefer-rest-params
    _info.apply(console, arguments);
  }
};

export const dynamicSort = (property) => {
  const sortOrder = 1;
  return function (a, b) {
    if (sortOrder === -1) {
      return b[property].localeCompare(a[property]);
    }
    return a[property].localeCompare(b[property]);
  };
};

// FIRST LETTER CAPITAL
export const CAPITALIZE = (str) => str.charAt(0).toUpperCase() + str.slice(1);

// STORE USERNAME AND PASSWORD IN LOCAL STORAGE
export const storeUserNameAndPassword = (user) => {
  localStorage.setItem(USERNAME_STORAGE_KEY, JSON.stringify(user));
};

// GET USER FROM LOCAL STORAGE
export const getUserNameAndPassword = async () => {
  const user = await localStorage.getItem(USERNAME_STORAGE_KEY);
  return user !== 'null' && !isEmpty(user) ? JSON.parse(user) : DEFAULT_USER;
};

export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// STORE SYNC DATE IN LOCAL STORAGE
export const storeSyncDate = (date) => {
  localStorage.setItem(SYNC_DATE_KEY, JSON.stringify(date));
};

// GET SYNC DATE FROM LOCAL STORAGE
export const getSyncDate = async () => {
  const date = await localStorage.getItem(SYNC_DATE_KEY);
  return date !== null && !isEmpty(date) ? JSON.parse(date) : momentDateAndTime().format('YYYY-MM-DD');
};

// STORE SYNC team_abb IN LOCAL STORAGE
export const storeSyncTeamAbb = (data) => {
  localStorage.setItem(SYNC_TEAM_ABB_KEY, JSON.stringify(data));
};

// GET SYNC team_abb FROM LOCAL STORAGE
export const getSyncTeamAbb = async () => {
  const data = await localStorage.getItem(SYNC_TEAM_ABB_KEY);
  return data !== 'null' && !isEmpty(data) ? JSON.parse(data) : '';
};

export const shorten = (s, max) => (`${s}`.length > max ? `${s.toString().substring(0, (max / 2) - 1)}...${s.toString().substring(`${s}`.length - (max / 2) + 2, `${s}`.length)}` : s);

// GET SYNC INVENTORY DATE FROM LOCAL STORAGE
export const getSyncInventoryDate = async () => {
  const date = await localStorage.getItem(SYNC_INVENTORY_DATE_KEY);
  return date !== null && !isEmpty(date) ? JSON.parse(date) : '';
};

// STORE SYNC INVENTORY DATE IN LOCAL STORAGE
export const storeSyncInventoryDate = (date) => {
  localStorage.setItem(SYNC_INVENTORY_DATE_KEY, JSON.stringify(date));
};

// UNSHIFT "CREATE NEW SESSION"
export const createNewSession = async (data, sortKey) => {
  let spliceObj = {};
  const resolvePromiseAll = data.map((value, key) => {
    if (value[sortKey] === 'CREATE NEW SESSION') {
      const a = data.splice(key, 1);
      // eslint-disable-next-line prefer-destructuring
      spliceObj = a[0];
    }
  });
  await Promise.all(resolvePromiseAll);
  data.unshift(spliceObj);
  return data;
};

export const screenWidth = window.screen.width;

export const desktopSearchArea = {
  x: 0.1, y: 0.30, width: 0.8, height: 0.07
};

export const mobileSearchArea = {
  x: 0.1, y: 0.10, width: 0.8, height: 0.07
};

export const create_UUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    // eslint-disable-next-line no-bitwise,no-mixed-operators
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
  return uuid;
};

// STORE LAST VISITED ROUTE IN LOCAL STORAGE
export const storeLastVisitedRoute = (data) => {
  localStorage.setItem(LAST_VISITED_ROUTE, JSON.stringify(data));
};

// GET LAST VISITED ROUTE IN LOCAL STORAGE
export const getStoreLastVisitedRoute = async () => {
  const data = await localStorage.getItem(LAST_VISITED_ROUTE);
  return data !== 'null' && !isEmpty(data) ? JSON.parse(data) : '';
};

// Get array of months
export const Months = [
  { text: 'January', id: 1 },
  { text: 'February', id: 2 },
  { text: 'March', id: 3 },
  { text: 'April', id: 4 },
  { text: 'May', id: 5 },
  { text: 'June', id: 6 },
  { text: 'July', id: 7 },
  { text: 'August', id: 8 },
  { text: 'September', id: 9 },
  { text: 'October', id: 10 },
  { text: 'November', id: 11 },
  { text: 'December', id: 12 },
];

// Get array of years
const rangeOfYears = (start, end) => Array(end - start + 1)
  .fill(start)
  .map((year, index) => year + index).reverse();

export const Years = rangeOfYears(
  new Date('Jan 1 1975').getFullYear(),
  new Date().getFullYear(),
);

// Get array of days
export const Days = [
  '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20',
  '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'
];

export const Fcm_Token = navigator.userAgent;

// STORE LAST VISITED ROUTE IN LOCAL STORAGE
export const storeInventoryFlag = (data) => {
  localStorage.setItem(INVENTORY_FLAG, JSON.stringify(data));
};

// GET LAST VISITED ROUTE IN LOCAL STORAGE
export const getInventoryFlag = async () => {
  const data = await localStorage.getItem(INVENTORY_FLAG);
  return data !== 'null' && !isEmpty(data) ? JSON.parse(data) : '';
};

// STORE isDER flag based on selected team territories
export const storeDERFlag = (data) => {
  localStorage.setItem(DER_FLAG, JSON.stringify(data));
};

// GET isDER flag IN LOCAL STORAGE
export const getDERFlag = async () => {
  const data = await localStorage.getItem(DER_FLAG);
  return data !== 'null' && !isEmpty(data) ? JSON.parse(data) : '';
};

export const isStartsWithNumber = (str) => /^\d/.test(str);

// Generate Random alphabetic string
// eslint-disable-next-line no-bitwise
export const compactRandomStringMaker = (length) => length-- && 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.charAt(Math.random() * 62 | 0) + (compactRandomStringMaker(length) || '');

// STORE CASE START DATE
export const storeListCaseDate = (data) => {
  localStorage.setItem(LIST_CASE_DATE_KEY, JSON.stringify(data));
};

// GET CASE START DATE
export const getListCaseDate = async () => {
  const listCaseDate = await localStorage.getItem(LIST_CASE_DATE_KEY);
  const date = listCaseDate != null && Object.keys(listCaseDate).length > 0
    ? JSON.parse(listCaseDate)
    : {};
  return date;
};

// Format number to sales percentage
export const getFormattedPercentage = (value) => {
  if (!value) return 0;
  return `${value > 0
    ? '+'
    : ''}${value.toFixed()}%`;
};

// Shallow compare two objects
export const shallowCompare = (obj1, obj2) => Object.keys(obj1).length === Object.keys(obj2).length
  && Object.keys(obj1).every((key) => obj1[key] === obj2[key]);

// Get percentage increase between two numbers
export const getPercentageIncrease = (current, previous) => {
  if (previous === 0) return 0;
  return ((current - previous) / previous) * 100;
};

export const getTerritoryData = (user) => {
  try {
    if (!user) return null;
    const { territories, office } = user;
    const territoryData = territories.find((item) => item.offices.some(
      (value) => value.id === office
    ));
    return territoryData;
  } catch (error) {
    Bugsnag.notify(error);
    return null;
  }
};

export const getTeamData = (user) => {
  try {
    if (!user) return null;
    const { selectedTeam } = user;
    return selectedTeam;
  } catch (error) {
    Bugsnag.notify(error);
    return null;
  }
};

export const getLocationsList = (locations) => {
  const sortedLocations = sortData(locations, 'LocName').filter((loc) => loc.LocName);
  const officeLocations = sortedLocations.filter((loc) => loc.LocName.toUpperCase().includes('OFFICE'));
  const otherLocations = sortedLocations.filter((loc) => !loc.LocName.toUpperCase().includes('OFFICE'));

  return [...officeLocations, ...otherLocations];
};

export const convertServerDateToTeamZone = (dateString, serverTimezone) => {
  if (!dateString || !serverTimezone) return null;
  // const user = getUser();
  // const teamData = getTeamData(user);
  // const momentObj = moment.tz(dateString, serverTimezone);
  // return momentObj.tz(teamData.timezone);
  const momentObj = moment.tz(dateString);
  return momentObj;
};

export const convertUTCtoTeamZone = (dateString) => {
  // const user = getUser();
  // const teamData = getTeamData(user);
  // const momentObj = moment.utc(dateString);
  // return momentObj.tz(teamData.timezone);
  const momentObj = moment.utc(dateString);
  return momentObj;
};

export const dayMap = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6
};

export const handleProductsButtonClick = (
  online,
  caseDetail,
  selectedDate,
  modals,
  scanner,
  VHN_PPC,
  VHN_Other,
  VRAS_PPC,
  VRAS_Other,
  notify,
  hospitalUseCustCaseIDStatus
) => {
  console.log(caseDetail);
  const {
    CaseDate,
    CaseScheduleID,
    ACMCaseID,
    MRN,
    PatientID,
    CaseType,
    id,
    DGR,
    case_products,
    CustCaseID,
    ProductSubmitted,
  } = caseDetail;
  const {
    addPatientIdOrMrn,
    addCustomerCaseID,
    addVhnPpc,
    addVrasPpc
  } = modals;
  const TODAY = moment();
  const showErrorMessage = (errorMessage) => {
    notify({ type: 'error', message: errorMessage, time: 3 });
  };
  const MRNisEmpty = MRN === null || MRN === '';
  const PatientIDisEmpty = PatientID === null || PatientID === '';
  const CustCaseIDisEmpty = CustCaseID === null || CustCaseID === '';
  const productsLength = case_products.length;
  const isVHN = VHN_PPC === '1' || VHN_Other === '1';
  const isVARS = VRAS_PPC === '1' || VRAS_Other === '1';
  const isDGR = DGR === '1';
  const returnRoutes = {
    ADD_PRODUCTS: `/manage-case/${id}/products/add`,
    LIST_PRODUCTS: `/manage-case/${id}/products/list`
  };

  // ACMCaseID check
  if (ACMCaseID !== null) {
    if (online) {
      if (moment(CaseDate) > TODAY) {
        return `/manage-case/${id}/acm-products`;
      }

      return `/manage-case/${id}/products`;
    }

    showErrorMessage('Products cannot be viewed without an internet connection.');
    return;
  }

  // Future date check
  if (moment(CaseDate) > TODAY || moment(selectedDate) > TODAY) {
    showErrorMessage('You can\'t add or view products for a case in the future');
    return;
  }

  // Online mode
  if (online) {
    console.log('1');
    if (CaseScheduleID === null) {
      showErrorMessage('Case must be submitted and have a CaseNo before scanning products.');
      return;
    }

    if (scanner && MRNisEmpty && PatientIDisEmpty) {
      if (isDGR) {
        return returnRoutes.LIST_PRODUCTS;
      }
      addPatientIdOrMrn();
      return;
    }

    if (scanner && hospitalUseCustCaseIDStatus && CustCaseIDisEmpty && (ProductSubmitted === null || ProductSubmitted !== '1')) {
      if (isDGR) {
        return returnRoutes.LIST_PRODUCTS;
      }
      addCustomerCaseID();
      return;
    }

    console.log('2');
    // if (scanner && productsLength >= 0 && CaseType === 'HIP' && isVHN && DGR === '0') {
    if (scanner && CaseType === 'HIP' && isVHN && DGR === '0') {
      console.log('3');
      addVhnPpc();
      return;
    }

    console.log('4');
    // if (scanner && productsLength > 0 && CaseType === 'KNEE' && isVARS && DGR === '0') {
    if (scanner && CaseType === 'KNEE' && isVARS && DGR === '0') {
      console.log('5');
      addVrasPpc();
      return;
    }

    if (scanner && productsLength === 0 && isDGR) {
      console.log('6');
      return returnRoutes.LIST_PRODUCTS;
    }

    if (scanner && productsLength > 0) {
      console.log('7');
      return returnRoutes.LIST_PRODUCTS;
    }

    if (scanner && moment(CaseDate) <= moment()) {
      console.log('8');
      return returnRoutes.ADD_PRODUCTS;
    }

    if (!scanner && productsLength === 0) {
      showErrorMessage('No products have been recorded for this case');
      return;
    }

    if (!scanner && productsLength > 0) {
      console.log('9');
      return returnRoutes.LIST_PRODUCTS;
    }

    return;
  }

  console.log('10');
  // Offline mode
  // if (!MRNisEmpty || !PatientIDisEmpty) {
  //   console.log('11');
  //   if (productsLength === 0) {
  //     console.log('12');
  //     if (CaseType !== 'HIP' && CaseType !== 'KNEE') {
  //       return returnRoutes.ADD_PRODUCTS;
  //     }

  //     if (CaseType === 'HIP' && !isVHN) {
  //       return returnRoutes.ADD_PRODUCTS;
  //     }

  //     if (CaseType === 'KNEE' && !isVARS) {
  //       return returnRoutes.ADD_PRODUCTS;
  //     }
  //   }

  //   console.log('13');
  //   if (CaseType !== 'HIP' && CaseType !== 'KNEE') {
  //     console.log('14');
  //     return returnRoutes.LIST_PRODUCTS;
  //   }
  // }

  if (MRNisEmpty && PatientIDisEmpty) {
    addPatientIdOrMrn();
    return;
  }

  if (hospitalUseCustCaseIDStatus && CustCaseIDisEmpty && (ProductSubmitted === null || ProductSubmitted !== '1')) {
    addCustomerCaseID();
    return;
  }

  console.log('15');
  // if (productsLength >= 0 && CaseType === 'HIP' && isVHN && DGR === '0') {
  if (CaseType === 'HIP' && isVHN && DGR === '0') {
    console.log('16');
    addVhnPpc();
    return;
  }

  console.log('17');
  console.log(isVARS);
  console.log(DGR);
  // if (productsLength >= 0 && CaseType === 'KNEE' && isVARS && DGR === '0') {
  if (CaseType === 'KNEE' && isVARS && DGR === '0') {
    console.log('18');
    addVrasPpc();
    return;
  }

  return returnRoutes.LIST_PRODUCTS;
};

// STORE THEME IN LOCAL STORAGE
export const storeThemeColor = (theme) => {
  localStorage.setItem(THEME_COLOR, theme);
};

// GET THEME IN LOCAL STORAGE
export const getThemeColor = async () => {
  const serverData = await localStorage.getItem(THEME_COLOR);
  return `${serverData}`;
};

// STORE THEME IN LOCAL STORAGE
export const storeThemeColorNumber = (theme) => {
  localStorage.setItem(THEME_COLOR_NUMBER, theme);
};

// GET THEME IN LOCAL STORAGE
export const getThemeColorNumber = async () => {
  const serverData = await localStorage.getItem(THEME_COLOR_NUMBER);
  return `${serverData}`;
};

export const _getPreferredColorScheme = async () => {
  try {
    const themeColor = await getThemeColor();
    const bodyClass = document.body.classList;

    bodyClass.remove('light-theme');
    bodyClass.remove('dark-theme');

    bodyClass.add(`${themeColor}-theme`);

    if (themeColor === 'light') {
      document.documentElement.style.setProperty('background', '#FFFFFF');
    } else {
      document.documentElement.style.setProperty('background', '#212121');
    }
  } catch (e) {
    Bugsnag.notify(e);
  }
};

export const clearAllLocalStorage = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
  localStorage.removeItem(FIRST_LOGIN_TOKEN_KEY);
  localStorage.removeItem(SERVER_URL_STORAGE_KEY);
  localStorage.removeItem(USERNAME_STORAGE_KEY);
  localStorage.removeItem(SYNC_DATE_KEY);
  localStorage.removeItem(SYNC_TEAM_ABB_KEY);
  localStorage.removeItem(SYNC_INVENTORY_DATE_KEY);
  localStorage.removeItem(LAST_VISITED_ROUTE);
  localStorage.removeItem(INVENTORY_FLAG);
  localStorage.removeItem(DER_FLAG);
  localStorage.removeItem(LIST_CASE_DATE_KEY);
};
